<div>
    <button (click)="open()" class="slant-button"  [style.fontSize]="data.categoryFontSize"  >{{menuData.categoryName | characterPipe}}</button>

</div>
